"use strict";
/*
 * Created on 4. 11. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var SettingsChildrenStats_1 = require("../../../general-settings/model/dto/SettingsChildrenStats");
/**
 * <p>During {@link SelloutRelease} creation process, user selects {@link ProductCategory}, which he/she wants to have as
 * part of the release. User selects categories not only based on their lists, his decision is affected by the number of items
 * determines for sellout of specific sellout type, for which he can create a new release. User can affect the number of these
 * items by filtering them, using {@link SelloutItemFilter}.</p>
 *
 * <p>Data structure is also used for inclusion/exclusion settings of product category within sellout release.</p>
 *
 * <p>Calculation of the counts stats may be computationally complex. <b>Since PROFACT-166, instances of this entity are persisted.</b></p>
 *
 * @author Radek Beran
 * @author JMe (refactoring with respect to PROFACT-166)
 */


var SelloutReleaseCategoryPreview =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutReleaseCategoryPreview, _DomainObject_1$Domai);

  /**
   * Ctor.
   *
   * @param id
   * @param releaseId Identification of {@link SelloutRelease} for which this preview is computed for.
   * @param categoryId Identification of {@link ProductCategory product category}.
   * @param includedInRelease Flag denoting that this entire product category will included in {@link SelloutRelease}.
   * @param inPathToIncluded True if some child category of this product category tree is included within the release. When category which
   *        is included in release is reached (if any), this value is false and remains false to the end of category tree.
   * @param childrenStats Count of included/of all child categories.
   * @param itemsCount Preview of number of potential sellout items for which a new {@link SelloutRelease} is about to be created for.
   *        The count is directly affected by {@link SelloutItemFilter}.
   * @param productsCount Number of unique products from previewed sellout items.
   * @param sitesCount Number of unique sites in counted sellout items.
   * @param itemFilterHash Hash code of {@link SelloutItemFilter} based on which previews were calculated.
   */
  function SelloutReleaseCategoryPreview(id, releaseId, categoryId, includedInRelease, inPathToIncluded, childrenStats, itemsCount, productsCount, sitesCount, itemFilterHash) {
    var _this;

    _classCallCheck(this, SelloutReleaseCategoryPreview);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseCategoryPreview).call(this));
    _this.id = id;
    _this.releaseId = releaseId;
    _this.categoryId = categoryId;
    _this.includedInRelease = includedInRelease;
    _this.inPathToIncluded = inPathToIncluded;
    _this.childrenStats = childrenStats;
    _this.itemsCount = itemsCount;
    _this.productsCount = productsCount;
    _this.sitesCount = sitesCount;
    _this.itemFilterHash = itemFilterHash;
    return _this;
  }

  return SelloutReleaseCategoryPreview;
}(DomainObject_1.DomainObject);

exports.SelloutReleaseCategoryPreview = SelloutReleaseCategoryPreview; // tslint:disable-next-line:member-ordering

SelloutReleaseCategoryPreview.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SelloutReleaseCategoryPreview.name);
  return {
    id: builder.id('id'),
    releaseId: builder.id('releaseId'),
    categoryId: builder.id('categoryId'),
    includedInRelease: builder.bool('includedInRelease'),
    inPathToIncluded: builder.bool('inPathToIncluded'),
    childrenStats: builder.obj('childrenStats', SettingsChildrenStats_1.SettingsChildrenStats.schema, function (mat) {
      return SettingsChildrenStats_1.SettingsChildrenStats.fromDataDict(mat);
    }),
    itemsCount: builder.num('itemsCount'),
    productsCount: builder.num('productsCount'),
    sitesCount: builder.num('sitesCount'),
    itemFilterHash: builder.num('itemFilterHash')
  };
}();